import { notSelectedValue } from "@pages/shops/[uuid]/request_reservation";
import { PredefinedToolTips, ToolTip } from "@components/ToolTip";
import { ReservationFormRow } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormRow";
import { ReservationFormSelect } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormSelect";
import { getPersonNumOptions } from "./_personNumRange";
import type { FrameForPersonNumRange } from "./_personNumRange";
import type { FC } from "react";

type Props = {
  /** 選択中の日付/試合で取得済みのフレーム群。未取得時は空配列で 1〜20 をフォールバック表示する。 */
  frames: ReadonlyArray<FrameForPersonNumRange>;
};

export const ReservationFormPersonNumRow: FC<Props> = ({ frames }) => {
  const personNumOptions = getPersonNumOptions(frames);

  return (
    <ReservationFormRow
      title="人数"
      toolTip={<ToolTip toolTip={PredefinedToolTips.personNum} />}
    >
      <ReservationFormSelect name={"personNum"} required={true}>
        <option value={notSelectedValue} disabled>
          選択してください
        </option>
        {personNumOptions.map((num) => (
          <option key={num} value={num.toString()}>
            {num}名
          </option>
        ))}
      </ReservationFormSelect>
    </ReservationFormRow>
  );
};
